import { getContracts } from 'app/employer/services/AutoSuggestServices';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

const handleApiDataResponse = (data = []) => {
   return data.map((option = {}) => {
      return ({
         ...option,
         label: `(${ option?.id }) ${ option?.name }`,
      });
   });
};

export default withAutosuggestWrapper(
   withInputErrorMessage(
      autosuggestFactory({
         apiPromise: getContracts,
         handleApiDataResponse,
      }),
   ),
);

